import React, { useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import { useTaggedCargoLatestData } from "./useLatestCargoData";
import { CargoStatus } from "./status";
import { PitchAndRoll } from "./pitchAndRoll";
import { Navigation } from "./navigation";
import { Mimic } from "./mimic";
import { TankFillStatus } from "./tankFillStatus";
import { CargoStatusGauge } from "./statusGauge";
import { Temperature } from "./temperature";
import { Pressure } from "./pressure";
import { CARGO_PAGES } from "../../constants/cargo/pages";
import { CARGO_CHARTS } from "../../constants/cargo/constants";

const classes = (theme) =>({
  container: {
    height: "calc(100dvh - 140px)",
    width: "calc(100vw - 240px)",
    margin: "0 0 0 50px",
    [theme.breakpoints.down('lg')]: {
      width: "calc(100% - 16px)",
      margin: "auto",
      overflowX: "hidden",
    },
    fontFamily: "Inter",
    "userSelect": "none",
    "MozUserSelect": "none",
    "WebkitUserSelect": "none",
  },
  topContainer: {
    height: "350px",
    width: "calc(100% - 16px)",
    marginBottom: "16px",
    boxShadow: "0 10px 20px 0 rgba(0, 0, 0, 0.3)",
  },
  middleContainer: {
    height: "350px",
    width: "calc(100% - 16px)",
    marginBottom: "16px",
    boxShadow: "0 10px 20px 0 rgba(0, 0, 0, 0.3)",
  },
  bottomContainer: {
    height: "700px",
    width: "calc(100% - 16px)",
    marginBottom: "16px",
    boxShadow: "0 10px 20px 0 rgba(0, 0, 0, 0.3)",
  },
  leftContainer: {
    [theme.breakpoints.up('xl')]: {
      paddingRight: "8px",
    },
  },
  rightContainer: {
    [theme.breakpoints.up('xl')]: {
      paddingLeft: "8px",
    },
  },
  tankContainer: {
    [theme.breakpoints.down('xl')]: {
      paddingRight: "16px",
    },
  },
  maximized: {
    height: "100%",
  },
});

export const DisplayPage = (props) => {
  const { vesselId, page, latestData, interval, selectedChart, setSelectedChart, pageRef } = props;
  const [isMaximized, setMaximize] = useState(false);
  const updateMaximized = (val) => {
    setMaximize(isMaximized ? false : val);
  };
  const { taggedLatestData } = useTaggedCargoLatestData(latestData);
  const tagList = taggedLatestData.map((item) => ({tag: item.tag, channelName: item.chName}));
  return (
    <div ref={pageRef}>
      <Grid container sx={(theme) => ({...classes(theme).container})}>
        {!isMaximized && (
          <Grid item size={{xs:12, xl:7}} sx={(theme) => ({...classes(theme).topContainer, ...classes(theme).leftContainer}) }>
            <CargoStatus taggedLatestData={taggedLatestData} />
          </Grid>
        )}
        {!isMaximized && (
          <Grid item size={{xs:12, xl:5}} sx={(theme) => ({...classes(theme).topContainer, ...classes(theme).rightContainer})}>
            <PitchAndRoll taggedLatestData={taggedLatestData} />
          </Grid>
        )}
        {!isMaximized && (
          <Grid item size={{xs:12, xl:6}} sx={(theme) => ({...classes(theme).middleContainer, ...classes(theme).leftContainer})}>
            {page === CARGO_PAGES.TRANSPORT ? <Navigation vesselId={vesselId} /> : <Mimic vesselId={vesselId} />}
          </Grid>
        )}
        {!isMaximized && (
          <Grid item size={{xs:4, xl:2}} sx={(theme) => ({...classes(theme).middleContainer, ...classes(theme).leftContainer, ...classes(theme).rightContainer, ...classes(theme).tankContainer})}>
            <TankFillStatus taggedLatestData={taggedLatestData} />
          </Grid>
        )}
        {!isMaximized && (
          <Grid item size={{xs:8, xl:4}} sx={(theme) => ({...classes(theme).middleContainer, ...classes(theme).rightContainer})}>
            <CargoStatusGauge page={page} taggedLatestData={taggedLatestData} />
          </Grid>
        )}
        {(!isMaximized || isMaximized === CARGO_CHARTS.TEMPERATURE) && (
          <Grid
            item
            size={{xs:12}}
            sx={
              (theme) =>
              isMaximized === CARGO_CHARTS.TEMPERATURE ? classes(theme).maximized : classes(theme).bottomContainer
            }
          >
            <Temperature
              vesselId={vesselId}
              isMaximized={isMaximized}
              setMaximize={updateMaximized}
              latestData={latestData}
              page={page}
            />
          </Grid>
        )}
        {(!isMaximized || isMaximized === CARGO_CHARTS.PRESSURE) && (
          <Grid
            item
            size={{xs:12}}
            sx={
              (theme) =>
              isMaximized === CARGO_CHARTS.PRESSURE ? classes(theme).maximized : classes(theme).bottomContainer
            }
          >
            <Pressure
              vesselId={vesselId}
              tagList={tagList}
              isMaximized={isMaximized}
              setMaximize={updateMaximized}
              interval={interval}
              selectedChart={selectedChart}
              setSelectedChart={setSelectedChart}
              page={page}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

DisplayPage.propTypes = {
  vesselId: PropTypes.string,
  page: PropTypes.string,
  classes: PropTypes.object,
  latestData: PropTypes.array,
  interval: PropTypes.number,
  selectedChart: PropTypes.string,
  setSelectedChart: PropTypes.func,
};
